import { render, staticRenderFns } from "./ReadGuideViewPopup.vue?vue&type=template&id=587c73a9"
import script from "./ReadGuideViewPopup.vue?vue&type=script&lang=js"
export * from "./ReadGuideViewPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports